(function() {
    'use strict';
    angular
        .module('abcQualityMatchApp')
        .factory('UserGroupAuthority', UserGroupAuthority);

    UserGroupAuthority.$inject = ['$resource'];

    function UserGroupAuthority ($resource) {
        var resourceUrl =  'api/user-group-authorities/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
